import { axiosWithConfig } from '@assembly/config/axios'

export const uploadMedia = (payload: any) => {
  return axiosWithConfig.put(`/media/assembly/setup`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
